<template lang="pug">
  div#contact-view
    mainHeader
    div.box
      div.has-text-centered 
        strong.title Contact Information
      hr
      div.columns.is-centered
        div.column.is-8
          div.map-responsive
            //- iframe(src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1572.9674800567925!2d23.704494899999993!3d37.9553046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a1bc5765f398c7%3A0x33a6cb0624e6fd!2sMantzagriotaki+89%2C+Kallithea+176+72!5e0!3m2!1sen!2sgr!4v1443878700602")
            iframe(src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3145.309130503176!2d23.710286415669316!3d37.96991447972424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a1bce3ac5ac9a7%3A0x92eab16541856!2zzpTOt868zr_Phs-Ozr3PhM6_z4IgNTksIM6RzrjOrs69zrEgMTE4IDUx!5e0!3m2!1sel!2sgr!4v1596704383954!5m2!1sel!2sgr")
      hr
      div.columns
        div.column.is-2
          i.fa.fa-map-marker
            //- span  Mantzagriotaki 89, Kallithea, 17672
            span  Dimofontos 59, Ano Petralona, Athens, 11851
        div.column.is-2
          a(:href="`mailto:info@mindcore.gr`")
            i.fas.fa-envelope
              span  info@mindcore.gr
        div.column.is-2
          a(:href="`mailto:mindcore.gr@gmail.com`")
            i.fas.fa-envelope 
              span  mindcoregr@gmail.com
        div.column.is-3
          i.fas.fa-phone
            //- span  211 2163425
            span    211-4084711
        div.column.is-3
          i.fa.fa-mobile(aria-hidden="true")
            span  6974-530043
            
      
    //- Footer 
</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: 'contact',
  components: {
    MainHeader,
    Footer,
  }  
}
</script>

<style scoped>
.box {
    background-color: #E8E8E8;
}

hr {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    border-bottom-width: 80%;
    margin-bottom: 2rem;
}

.map-responsive{
    overflow:hidden;
    padding-bottom:56.25%;
    position:relative;
    height:0;
    /* padding-left: auto; */
    border: 1px hidden grey;
    border-radius: 1.5%;
}

.map-responsive iframe{
    left:0;
    top:0;
    height: 100%;
    width: 100%;
    position:absolute;
}

span {
    font-weight: 100;
    font-family:Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 16px;
    color: rgb(74, 74, 74);
}
</style>

